<template>
  <div class="admin-page admin-page-panel">
    <div class="admin-filter-bar">
      <a-button type="default" icon="reload" @click="loadData">刷新</a-button>
    </div>

    <a-table 
      :columns="columns" 
      :data-source="data" 
      rowKey="id" 
      :loading="loading" 
      :pagination="pagination"
      @change="handleTableChange"
    >
    </a-table>
  </div>
</template>

<script>
import { getLogList } from '@/api'

export default {
  data() {
    return {
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '操作者', dataIndex: 'username', width: '100px' },
        { title: '操作名称', dataIndex: 'operation', width: '150px' },
        { title: '方法名', dataIndex: 'method', ellipsis: true },
        { title: '参数', dataIndex: 'params', ellipsis: true },
        { title: '耗时(ms)', dataIndex: 'time', width: '100px' },
        { title: 'IP', dataIndex: 'ip', width: '120px' },
        { title: '时间', dataIndex: 'createTime', width: '180px' }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getLogList({
        page: this.pagination.current,
        size: this.pagination.pageSize
      }).then(res => {
         if (res.data.records) {
             this.data = res.data.records
             this.pagination.total = res.data.total
        } else {
             this.data = res.data
             this.pagination.total = res.data.length
        }
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    }
  }
}
</script>
